import realtimeApi from "@/apis/realtime.api.js";
import airLevel from "@/libs/air.level.js";
import commonApi from "@/apis/common.api";
import {$_DKD, $_ADM} from "@/confs/common.const";
import {$_TYPE} from "@/confs/common.const";
import gripUtil from "@/libs/grip.util";

export default {
    state: {
        // 날씨 정보
        airSpace: {},
        // 동별 날씨
        airHjdList: [],
        // 구별 날씨
        airSggList: [],
        // 환경센서
        airHjdSensorList: [],
        // 강우량
        rainfallList: [],
        rainfallMap: {},
        // 대기질 예보통보
        airForecastList: [],
        // 구 대기 정보 (장비 별)
        airGu: [],
        // 서울시 대기 정보 (구 별)
        airSi: [],
        airHjdMeta: {
            pm10: {name: '미세먼지', valCol: 'fineDust', unit: 'µg/m³', levelFun: airLevel.pm10Level, sggCol: 'val3'},
            pm25: {name: '초미세먼지', valCol: 'ultraFineDust', unit: 'µg/m³', levelFun: airLevel.pm25Level, sggCol: 'val4'},
            no2: {name: '이산화질소', valCol: 'no2', unit: 'ppm', levelFun: airLevel.no2Level, sggCol: 'val8'},
            o3: {name: '오존', valCol: 'o3', unit: 'ppm', levelFun: airLevel.o3Level, sggCol: 'val6'},
            decibel: {name: '소음', valCol: 'decibelAvg', unit: 'dB', levelFun: airLevel.decibelLevel},
            rain: {name:'강우량', valCol: 'val5', unit:'mm', levelFun:airLevel.rainfallLevel},
            mosquito: {name:'모기방역', valCol: 'val5', unit:'건', levelFun:airLevel.rainfallLevel},
            mediumMosq: {name: '매개모기', valCol: 'val4', unit: '마리', levelFun:airLevel.rainfallLevel},
        },
        // 행정동 대기 측정 장비 맵핑
        airEquUmdMap: {
            '1168051000': '강남구',           //신사동
            '1168052100': '강남구',           //논현1동
            '1168053100': '강남구',           //논현2동
            '1168054500': '강남구',           //압구정동
            '1168056500': '강남구',           //청담동
            '1168058000': '강남구',           //삼성1동
            '1168059000': '강남구',           //삼성2동
            '1168060000': '강남구',           //대치1동
            '1168061000': '강남구',           //대치2동
            '1168063000': '강남구',           //대치4동
            '1168064000': '강남구',			//역삼1동
            '1168065000': '도산대로',         	//역삼2동
            '1168065500': '도산대로',         	//도곡1동
            '1168065600': '도산대로',         	//도곡2동
            '1168066000': '도산대로',         	//개포1동
            '1168067000': '도산대로',         	//개포2동
            '1168069000': '도산대로',         	//개포4동
            '1168070000': '도산대로',         	//세곡동
            '1168072000': '도산대로',         	//일원본동
            '1168073000': '도산대로',         	//일원1동
            '1168074000': '도산대로',         	//일원2동
            '1168075000': '도산대로',         	//수서동
        },
        // 체감온도_어린이
        childtemperature: {},
        // 체감온도_노인
        oldtemperature: {},
        // 자외선
        uv: {},
        // 동파가능지수
        freeze: {},
        //동 강우량계 현황
        dongRainfallInfo: {},
    },
    getters: {
        getAirSpace(state) {
            return state.airSpace;
        },
        getAirHjdList(state) {
            return state.airHjdList;
        },
        getAirSggList(state) {
            return state.airSggList;
        },
        getAirHjdSensorList(state) {
            return state.airHjdSensorList;
        },
        getRainfallList(state) {
            return state.rainfallList;
        },
        getRainfallMap(state) {
            return state.rainfallMap;
        },
        getAirForecastList(state) {
            return state.airForecastList;
        },
        getAirGu(state) {
            return state.airGu;
        },
        getAirSi(state) {
            return state.airSi;
        },
        getAirHjdMeta(state) {
            return state.airHjdMeta;
        },
        getAirHjdAirEquMap(state) {
            return state.airHjdAirEquMap;
        },
        getChildtemperature(state) {
            return state.childtemperature;
        },
        getOldtemperature(state) {
            return state.oldtemperature;
        },
        getUv(state) {
            return state.uv;
        },
        getFreeze(state) {
            return state.freeze;
        },
        getDongRainfallInfo(state) {
            return state.dongRainfallInfo;
        },
    },
    mutations: {
        AIRSPACE(state, airSpace) {
            state.airSpace = airSpace;
        },
        AIR_HJD_LIST(state, airHjdList) {
            state.airHjdList = airHjdList;
        },
        AIR_SGG_LIST(state, airSggList) {
            state.airSggList = airSggList;
        },
        AIR_HJD_SENSOR_LIST(state, airHjdSensorList) {
            state.airHjdSensorList = airHjdSensorList;
        },
        RAINFALL_LIST(state, rainfallList) {
            state.rainfallList = rainfallList;
        },
        RAINFALL_MAP(state, rainfallMap) {
            state.rainfallMap = rainfallMap;
        },
        AIR_FORECAST_LIST(state, airForecastList) {
            state.airForecastList = airForecastList;
        },
        AIR_GU(state, airGu) {
            state.airGu = airGu;
        },
        AIR_SI(state, airSi) {
            state.airSi = airSi;
        },
        CHILD_TEMPERATURE(state, childtemperature) {
            state.childtemperature = childtemperature;
        },
        OLD_TEMPERATURE(state, oldtemperature) {
            state.oldtemperature = oldtemperature;
        },
        UV(state, uv) {
            state.uv = uv;
        },
        FREEZE(state, freeze) {
            state.freeze = freeze;
        },
        DONG_RAINFALL_INFO(state, dongRainfallInfo) {
            state.dongRainfallInfo = dongRainfallInfo;
        },
    },
    actions: {
        FETCH_AIRSPACE({commit}) {
            return realtimeApi.fetchAirSpace()
                .then(res => {
                    commit('AIRSPACE', res.data.data);
                });
        },
        FETCH_AIR_HJD_LIST({commit}) {
            // return realtimeApi.fetchAirHjd()
            //     .then(function(res) {
            //         commit('AIR_HJD_LIST', res.data.data);
            //     });
        },
        FETCH_AIR_SGG_LIST({commit}) {
            return realtimeApi.fetchAirSgg()
                .then((res)=>{
                    commit('AIR_SGG_LIST', res.data.data);
                });
        },
        FETCH_AIR_HJD_SENSOR_LIST({commit}) {
            // return commonApi.fetchRepoDataList($_DKD.ENV_SENSOR, 'orderBy=basdtVal::desc&searchLimit=110')
            // return commonApi.fetchMaxBasdtValDataList($_DKD.ENV_SENSOR)
            //     .then(res => {
            //         const airHjdSensorMap = {};
            //         let airHjdSensorList = [];
            //         console.log('res', res);
            //         console.log('ADDONG_NM_MAP', $_ADM.ADDONG_NM_MAP);
            //         res.data.data.forEach((d)=>{
            //             if(d.val5 === '일원2동'){
            //                 d.val5 = '개포3동';
            //             }
            //             for(let addongNm in $_ADM.ADDONG_NM_MAP) {
            //                 if(d.val5 === addongNm){
            //                     let addongCd = $_ADM.ADDONG_NM_MAP[addongNm];
            //                     if(typeof airHjdSensorMap[addongCd] === 'undefined') {
            //                         airHjdSensorMap[addongCd] = {
            //                             addongHjbCd: addongCd,
            //                             addongHjbNm: addongNm,
            //                             lttdVal: $_ADM.ADDONG_CENTER_MAP[addongCd].lat,
            //                             lgtdVal: $_ADM.ADDONG_CENTER_MAP[addongCd].lng,
            //                             fineDust: 0,    //미세먼지
            //                             ultraFineDust: 0,   //초미세먼지
            //                             decibel: 0, //소음
            //                             fineDustIdx: 0, //미세먼지
            //                             ultraFineDustIdx: 0,    //초미세먼지
            //                             decibelIdx: 0,  //소음
            //                             basdtVal: (d.basdtVal.length === 10) ? d.basdtVal + '00' : d.basdtVal,
            //                         };
            //                         airHjdSensorList.push(airHjdSensorMap[addongCd]);
            //                     }
            //                     let fineDust = isNaN(d.val10) ? Number(0) : Number(d.val10);
            //                     let ultraFineDust = isNaN(d.val11) ? Number(0) : Number(d.val11);
            //                     let decibel = isNaN(d.val12) ? Number(0) : Number(d.val12);

            //                     airHjdSensorMap[addongCd].fineDust += fineDust;
            //                     airHjdSensorMap[addongCd].ultraFineDust += ultraFineDust;
            //                     airHjdSensorMap[addongCd].decibel += decibel;
            //                     airHjdSensorMap[addongCd].fineDustIdx++;
            //                     airHjdSensorMap[addongCd].ultraFineDustIdx++;
            //                     airHjdSensorMap[addongCd].decibelIdx++;
            //                 }
            //             }
            //         });
            //         airHjdSensorList.forEach((airHjdSensorInfo)=>{
            //             airHjdSensorInfo['fineDustAvg'] = (airHjdSensorInfo.fineDust / airHjdSensorInfo.fineDustIdx).toFixed(0);
            //             airHjdSensorInfo['ultraFineDustAvg'] = (airHjdSensorInfo.ultraFineDust / airHjdSensorInfo.ultraFineDustIdx).toFixed(0);
            //             airHjdSensorInfo['decibelAvg'] = (airHjdSensorInfo.decibel / airHjdSensorInfo.decibelIdx).toFixed(0);
            //         });
            //         // commit('AIR_HJD_SENSOR_LIST', res.data.data);
            //         console.log('airHjdSensorList', airHjdSensorList);
            //         commit('AIR_HJD_SENSOR_LIST', airHjdSensorList);
            //     });
            // 근접측정소 목록에서 측정소 추출해서 해당 측정소 값 조회로 변경 번호 자료종류번호로 추가 필요.
            // 기준일 최신에서 측정소별 최신 값으로 변경
            let q = 'orderBy=basdtVal::desc&searchLimit=50';
            return commonApi.fetchRepoDataList($_DKD.AIR_STATION_VL, q).then(response => {
                // let measureList = response.data.data;
                // let measureMap = gripUtil.toDict(measureList, 'val2');

                let measureList = [];
                let measureMap = gripUtil.toMap(response.data.data, 'val2');
                for(let key in measureMap) {
                    measureMap[key].sort((pre, cur) => {
                        return Number(cur.basdtVal) - Number(pre.basdtVal);
                    });
                    measureList.push(measureMap[key][0]);
                }
                const airHjdSensorMap = {};
                let airHjdSensorList = [];
                measureList.forEach(d => {
                    for(let addongNm in $_ADM.ADDONG_NM_MAP) {
                        let addongCd = $_ADM.ADDONG_NM_MAP[addongNm];
                        let stationCd = $_ADM.ADDONG_NM_STATION_MAP[addongNm];
                        if(d.val2 == stationCd) {
                            if(typeof airHjdSensorMap[addongCd] === 'undefined') {
                                

                                airHjdSensorMap[addongCd] = {
                                    addongHjbCd: addongCd,
                                    addongHjbNm: addongNm,
                                    lttdVal: $_ADM.ADDONG_CENTER_MAP[addongCd].lat,
                                    lgtdVal: $_ADM.ADDONG_CENTER_MAP[addongCd].lng,
                                    fineDust: d.val8 == '-' ? '점검중' : Number(d.val8),    //미세먼지
                                    ultraFineDust: d.val10 == '-' ? '점검중' : Number(d.val10),   //초미세먼지
                                    no2: d.val7 == '-' ? '점검중' : Number(d.val7), //이산화질소
                                    o3: d.val6 == '-' ? '점검중' : Number(d.val6),
                                    basdtVal: (d.basdtVal.length === 10) ? d.basdtVal + '00' : d.basdtVal,
                                };
                                
                                airHjdSensorList.push(airHjdSensorMap[addongCd]);
                            }
                        }
                    }
                });

                // 역삼동, 도곡동, 개포동의 경우 강남대로의 미세먼지, 초미세먼지, 이산화질소 값이 '-'인 경우가 많아서
                // 2번째 근접측정소 값으로 수정
                for(let addongCd in airHjdSensorMap) {
                    let addongNm = $_ADM.ADDONG_CENTER_MAP[addongCd].dongNm;
                    let stationCd = $_ADM.ADDONG_NM_SEC_STATION_MAP[addongNm];
                    let data = measureMap[stationCd][0];
                    if(airHjdSensorMap[addongCd].fineDust == '점검중') {
                        airHjdSensorMap[addongCd].fineDust = data.val8 == '-' ? '점검중' : data.val8;
                    }
                    if(airHjdSensorMap[addongCd].ultraFineDust == '점검중') {
                        airHjdSensorMap[addongCd].ultraFineDust = data.val10 == '-' ? '점검중' : data.val10;
                    }
                    if(airHjdSensorMap[addongCd].no2 == '점검중') {
                        airHjdSensorMap[addongCd].no2 = data.val7 == '-' ? '점검중' : data.val7;
                    }
                    if(airHjdSensorMap[addongCd].o3 == '점검중') {
                        airHjdSensorMap[addongCd].o3 = data.val6 == '-' ? '점검중' : data.val6;
                    }
                }
                commit('AIR_HJD_SENSOR_LIST', airHjdSensorList);
            });

        },

        FETCH_RAINFALL_LIST({commit}) {
            let today = new Date();
            let yesterDay = new Date(today - (3600000 * 24 * 1));
            let searchFromDate = yesterDay.format('yyyyMMdd')+'0000';
            let nowDate = today.format('yyyyMMdd')+'0000';
            let q = 'where=val3::101.0&orderBy=basdtVal::desc&searchFromDate=' + searchFromDate;
            let rainfallCenterMap = {};
            return commonApi.fetchRepoDataList($_DKD.RAINFALL, q)
                .then(res => {
                    if(res.data.data.length > 0) {
                        let maxTime = res.data.data[0].basdtVal;
                        let maxTimeString = maxTime.substring(0,4)+ "/"
                            + maxTime.substring(4,6)
                            + "/" + maxTime.substring(6,8)
                            + " " + maxTime.substring(8,10)
                            + ":" + maxTime.substring(10,12);

                        let beforeThreeHour = new Date(new Date(maxTimeString) - (3600000 * 3 * 1)).format('yyyyMMddHHmm');

                        res.data.data.forEach((d)=>{
                            let name = d.val2;
                            if(typeof rainfallCenterMap[name] === $_TYPE.UNDEF) {
                                rainfallCenterMap[name] = {
                                    centerCode : d.val1,
                                    centerNm : name,
                                    lttdVal : $_ADM.RAINFALL_CENTER_MAP[name].lat,
                                    lgtdVal : $_ADM.RAINFALL_CENTER_MAP[name].lng,
                                    threeHourSum : 0,   // 3시간 누적 강우량  -- 한가지로 변경해야함.
                                    todaySum : 0,       // 당일 누계
                                    lastestVal : 0,     // 현재 강우량
                                    basdtVal : maxTimeString,
                                };
                            }
                            if(Number(d.basdtVal) > Number(beforeThreeHour)) {
                                rainfallCenterMap[name].threeHourSum += Number(d.val5);
                            }
                            if(Number(d.basdtVal) >= Number(nowDate)) {
                                //당일 누계
                                rainfallCenterMap[name].todaySum += Number(d.val5);
                            }
                            if(d.basdtVal === maxTime) {
                                rainfallCenterMap[name].lastestVal = Number(d.val5);
                            }
                        });
                        commit('RAINFALL_LIST', res.data.data);
                        commit('RAINFALL_MAP', rainfallCenterMap);
                    }
                });
        },

        FETCH_AIR_FORECAST_LIST({commit}) {
            return realtimeApi.fetchAirForecastList()
                .then(res => {
                    commit('AIR_FORECAST_LIST', res.data.data);
                });
        },
        FETCH_AIR_GU({commit}) {
            return realtimeApi.fetchAirGu()
                .then(res => {
                    commit('AIR_GU', res.data.data);
                });
        },
        FETCH_AIR_SI({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.AIR_SI)
                .then(res => {
                    commit('AIR_SI', res.data.data);
                });
        },
        FETCH_CHILD_TEMPERATURE({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.CHILD_TEMPERATURE)
                .then(res => {
                    commit('CHILD_TEMPERATURE', res.data.data[0]);
                });
        },
        FETCH_OLD_TEMPERATURE({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.OLD_TEMPERATURE)
                .then(res => {
                    commit('OLD_TEMPERATURE', res.data.data[0]);
                });
        },
        FETCH_UV({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.UV)
                .then(res => {
                    commit('UV', res.data.data[0]);
                });
        },
        FETCH_FREEZE({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.FREEZE)
                .then(res => {
                    commit('FREEZE', res.data.data[0]);
                });
        },
        FETCH_DONG_RAINFALL_INFO({commit}) {
            let today = new Date();
            // 현재 날짜 기준 6시간 전
            let yesterDay = new Date(today.setHours(today.getHours()-6));
            let searchFromDate = yesterDay.format('yyyyMMddHHmm');

            let q = 'orderBy=basdtVal::desc&searchFromDate=' + searchFromDate;
            // let q = 'orderBy=basdtVal::desc';
            return commonApi.fetchRepoDataList($_DKD.DONG_RAINFALL, q)
            .then(res=> {
                if(res.data.data.length > 0) {
                    let list = res.data.data;
                    let hourFilterList = [];
                    const dongRainFallInfo = {};

                    let maxTime = list[0].basdtVal;
                    let maxTimeString = maxTime.substring(0, 4) + "/"
                        + maxTime.substring(4, 6)
                        + "/" + maxTime.substring(6, 8)
                        + " " + maxTime.substring(8, 10)
                        + ":" + maxTime.substring(10, 12);

                    let maxDate = new Date(maxTimeString);

                    //최신 데이터 기준 - 3시간 전 누적 데이터 가져오기
                    let beforeThreeHour = new Date(maxDate - (3600000 * 3)).format('yyyyMMddHHmm');

                    hourFilterList = list.filter(data => {
                        if (Number(data.basdtVal) >= beforeThreeHour) {
                            return true;
                        }
                    })

                    hourFilterList.forEach(data => {
                        let code = data.val2;
                        let centerNm = data.val1;

                        if (typeof dongRainFallInfo[centerNm] === $_TYPE.UNDEF) {
                            dongRainFallInfo[centerNm] = {
                                centerCode: code,
                                centerNm: centerNm,
                                lttdVal: $_ADM.RAINFALL_CENTER_MAP[centerNm].lat,
                                lgtdVal: $_ADM.RAINFALL_CENTER_MAP[centerNm].lng,
                                threeHourSum: 0,   // 3시간 누적 강우량  -- 한가지로 변경해야함.
                                todaySum: 0,       // 당일 누계
                                lastestVal: 0,     // 현재 강우량
                                yearSum: 0,     // 금년 누계
                                basdtVal: maxTimeString,
                            };
                        }

                        if (maxTime == data.basdtVal) {
                            dongRainFallInfo[centerNm].todaySum = data.val4;
                            dongRainFallInfo[centerNm].lastestVal = data.val3;
                            dongRainFallInfo[centerNm].yearSum = data.val5;
                        }
                        dongRainFallInfo[centerNm].threeHourSum = Number(dongRainFallInfo[centerNm].threeHourSum) + Number(data.val3);
                    })
                    commit('DONG_RAINFALL_INFO', dongRainFallInfo);
                }
            })
        },
    },
}
